import { notify } from 'react-notify-toast';

const alert = { background: '#e02f47', text: '#fff', };
const success = { background: '#20a66d', text: '#fff', };

export default (message, isSuccess = false) => notify.show(message || '', 'custom', 3000, isSuccess ? success : alert);
